import store from "../redux/store";
import { v4 as uuidv4 } from 'uuid';

export const formatColumnsFromElastic = (row) => {
    let { colIdObj } = store.getState().currentSheetDataReducer
    Object.keys(colIdObj).forEach((colId) => {
        if (row[colId]) {
            let colname = colIdObj[colId].field
            row[colname] = row[colId].value
        }
    })
    return row
}

export const makeSheetRowData = ({ user_id, user_email, sheet_identifier, uuid, workbook_id }) => {
    try {
        let rowData = {

            "user_id": `${user_id || user_email}`,
            "user_email": `${user_email}`,
            "workbook_id": workbook_id,
            "remote_datasource": "Elastic",
            "sheet_identifier": sheet_identifier,
            "attachments": [
            ],
            "notes": "Notes example"

        }
        return rowData
    } catch (error) {
        console.log("Error in generating rowData for Sheet", error)
    }
}
export const makeSheetRowDataWithPreDefinedRows = ({ user_id, user_email, uuid, workbook_id, rows, sheetType, newCols }) => {
    try {
        let colMap = {}
        newCols && newCols.forEach((col) => {
            colMap[`${col.colId?.toLowerCase()||"#"}`] = col.field
        })
        let rowsForDB = []
        rows.forEach((row) => {
            if (!row) return;
            let cellValues = {}
            Object.keys(row).forEach((key) => {
                // const isInColMapValues = Object.values(colMap).includes(key);
                if (colMap[key]) {
                    let cellDetails=row[key];
                    let isCellObject=false;
                    if (typeof cellDetails === 'object' && cellDetails !== null && 'value' in cellDetails) {
                        isCellObject =true
                    }
                    // cellValues[key] = isCellObject? cellDetails.value : cellDetails
                    cellValues[colMap[key] + '_es'] = {
                        value: isCellObject ? cellDetails.value : cellDetails,
                        "format":isCellObject? cellDetails.format: '',
                        "cellStyle":isCellObject? cellDetails.cellStyle: {},
                        "notes": "",
                        "attachments": [],
                        // "field": key,
                    }
                }
            })

            let rowData = {
                "id": row.id?row.id:row.key||uuidv4(),
                "l_id":row.l_id||uuidv4(),
                "user_id": `${user_id || user_email}`,
                "user_email": `${user_email}`,
                "workbook_id": workbook_id,
                "remote_datasource": "Elastic",
                "predecessorNodes":row.predecessorNodes || '',
                "successorNodes":row.successorNodes || '',
                "attachments": [
                ],
                "notes": "Notes example",
                sheetType: "",
                ...(row.isAzureRow ? { isAzureRow: true } : {}),
                ...cellValues
            }
            rowsForDB.push(rowData)
        })
        return { index: 'sheetrow', body: rowsForDB, numberOfDocs: 50 }
    }

    catch (error) {
        console.log("Error in generating rowData for Sheet", error)
    }
}
